/**
 * PageHeader — sticky sub-header shown on the service-request detail page.
 *
 * Contains a back-to-dashboard link, optional service title breadcrumb,
 * and an optional request-ID badge.
 */
import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { PALETTE_FOREST, PALETTE_CREAM, PALETTE_MINT } from '../tokens';

interface PageHeaderProps {
  serviceTitle?: string;
  requestId?:    string;
}

export function PageHeader({ serviceTitle, requestId }: PageHeaderProps) {
  return (
    <div
      className="sticky top-16 z-10 border-b border-border/60 backdrop-blur-sm"
      style={{ backgroundColor: `${PALETTE_CREAM}E6` }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 flex items-center gap-3">
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-1.5 text-sm font-medium transition-colors hover:opacity-70 shrink-0"
          style={{ color: PALETTE_FOREST }}
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Dashboard
        </Link>

        {serviceTitle && (
          <>
            <span className="text-border select-none" aria-hidden>/</span>
            <span className="text-sm font-semibold text-foreground truncate">
              {serviceTitle}
            </span>
          </>
        )}

        {requestId && (
          <span
            className="ml-auto shrink-0 text-[10px] font-mono font-semibold px-2 py-0.5 rounded"
            style={{ backgroundColor: PALETTE_MINT, color: PALETTE_FOREST }}
            title="Service Request ID"
          >
            #{requestId.split('-')[0]!.toUpperCase()}
          </span>
        )}
      </div>
    </div>
  );
}
